import Vue from 'vue';

// Photos of banned users are blurred until an admin/operator confirms they
// want to see them. Revealed photos are tracked per key (e.g. 'profileimage:12'
// or 'message:34') for the rest of the session.
export const state = () => ({
  revealed: {},
});

export const getters = {
  isVisible: (state) => (banned, key) => !banned || !!state.revealed[key],
};

export const mutations = {
  reveal(state, keys) {
    for (const key of [].concat(keys)) {
      Vue.set(state.revealed, key, true);
    }
  },
};
